import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getVideoSrc } from '../constants/constants';
import { appSignUp } from '../constants/constants';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';

const IntroCreatePlaybooksDragAndDrop = () => {
    const { t, i18n } = useTranslation();
    return (
        <Box
            sx={{
                minHeight: 'auto',
                display: 'flex',
                alignItems: { xs: 'flex-start', md: 'center' },
                justifyContent: 'center',
                p: { xs: 2, md: '160px 32px 0' },
                background: 'url(/images/overlay-1.webp) center/cover no-repeat',
                position: 'relative',
                paddingBottom: { xs: 10, md: 20 },
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    zIndex: 1,
                },
            }}
        >
            <Container
                maxWidth="lg"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    flexDirection: { xs: 'column', md: 'row' },
                    textAlign: { xs: 'center', md: 'left' },
                    position: 'relative',
                    zIndex: 2,
                }}
            >
                <Box sx={{ flex: 1, minWidth: 300, pt: { xs: 0, md: 4 } }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '2.9rem', sm: '3.4rem', md: '3.6rem' },
                            fontWeight: 800,
                            lineHeight: 1.2,
                            mb: 3,
                            color: '#1a202c',
                            mt: { xs: 12, sm: 16, md: 0 },
                        }}
                    >
                        {t('IntroCreatePlaybooksDragAndDrop00')}<br />
                        <Box
                            component="span"
                            sx={{
                                background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
                                backgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}
                        >
                            {t('IntroCreatePlaybooksDragAndDrop01')}
                        </Box>
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: '1.1rem',
                            color: 'black',
                            mb: 4,
                            lineHeight: 1.2,
                            maxWidth: 480,
                            mx: { xs: 'auto', md: 0 },
                        }}
                    >
                        {t('IntroCreatePlaybooksDragAndDrop02')}
                    </Typography>

                    <Button
                        onClick={() => window.location.href = appSignUp}
                        variant="contained"
                        endIcon={<ArrowOutwardRoundedIcon />}
                        sx={{
                            background: '#048cec',
                            color: 'white',
                            px: 4,
                            py: 1.5,
                            fontSize: '0.95rem',
                            fontWeight: 600,
                            borderRadius: '8px',
                            textTransform: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1,
                            whiteSpace: 'nowrap',
                            minWidth: 'fit-content',
                            boxShadow: '0 4px 15px rgba(252, 164, 68, 0.3)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 6px 20px rgba(252, 164, 68, 0.4)',
                                background: '#048cec',
                            },
                        }}
                    >
                        {t('IntroCreatePlaybooksDragAndDrop03')}

                    </Button>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: { xs: 'center', md: 'flex-end' },
                        alignItems: 'center',
                        right: { md: '-10%' },
                        mt: { xs: 2, md: 0 },
                    }}
                >
                    <video
                        src={getVideoSrc('intro-create-playbooks-with-drag-and-drop', i18n.language)}
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            borderRadius: 8,
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                        }}
                        aria-label="iCoachBasketball practice customization demo"
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default IntroCreatePlaybooksDragAndDrop;